export default class OurPeople {
  constructor() {
    this.carousel = document.querySelector('.our-people-rnd .carousel');

    // Initialize carousel
    this.flkty = new Flickity(this.carousel, {
      contain: true,
      pageDots: false,
      imagesLoaded: true,
      groupCells: true,
      cellAlign: 'center',
      on: {
        ready: () => {
          setTimeout(() => {
            this.carousel.querySelectorAll('.flickity-button').forEach((button) => {
              button.innerHTML = `
                <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L11 11L1 21" stroke="#111E90" stroke-width="2"/>
                </svg>
              `;
              
              if (this.flkty.slides.length < 2) {
                button.style.display = 'none';
              }
            });
          }, 0);
        }
      }
    });
  }
}
